var $ = require('jquery');
var menu = {
    init: function () {
        this.createElements();
        this.bindUIActions();
        this.setupAria();
    },
    bindUIActions: function () {
        $('.nav-toggle').on('click', function () {
            menu.toggleNav();
        });
        $(document).on('click', '.sub-menu-wrapper', function () {
            menu.sub - menuNav($(this));
        });
        $('li.menu-item-has-children > a').on('mouseenter', function () {
            console.log('moused over');
            menu.openAria($(this));
        });
        $('li.menu-item-has-children > a').on('mouseleave', function () {
            console.log('moused out');
            menu.closeAria($(this));
        });
    },
    toggleNav: function () {
        $('.header').toggleClass('active');
        $('.header-nav').toggleClass('active');
    },
    submenuNav: function (el) {
        var subMenu = el.find('.sub-menu');
        if (subMenu.hasClass('touch-open')) {
            // opened by clicking the parent on mobile device
            subMenu.removeClass('touch-open');
            menu.closeAria(subMenu);
        } else {
            subMenu.addClass('touch-open');
            menu.openAria(subMenu);
        }
    },
    setupAria: function () {
        $('.sub-menu-wrapper').each(function () {
            $(this).attr('aria-hidden', true).attr('aria-expanded', false);
        });
    },
    openAria: function (el) {
        el.parents().find('.sub-menu-wrapper').attr('aria-hidden', false).attr('aria-expanded', true);
    },
    closeAria: function (el) {
        el.parents().find('.sub-menu-wrapper').attr('aria-hidden', true).attr('aria-expanded', false);
    },
    createElements: function () {
        $('ul.sub-menu').each(function (index) {
            $(this).wrapAll('<div id="submenu-' + index + '" class="sub-menu-wrapper" />')
        });
        $('.sub-menu-wrapper').each(function () {
            var thisEl = $(this),
                firstMenuEl = thisEl.find('ul.sub-menu > li:first-child'),
                submenuImg = thisEl.parent().attr('data-nav-item-image'),
                submenuDsc = thisEl.parent().attr('data-nav-item-desc');
            if (submenuImg && submenuImg != '') {
                thisEl.append('<div class="image" style="background-image: url(\'' + submenuImg + '\')"><img class="visually-hidden" src="' + submenuImg + '" alt="' + firstMenuEl.text() + '" /></div>');
            }
            if (submenuDsc && submenuDsc != '') {
                firstMenuEl.append('<p>' + submenuDsc + '</p>');
            }
        });
    }
};
module.exports = menu;
